import {
  COUNTRIES,
  COUNTRY_MY,
  COUNTRY_ID,
  COUNTRY_VN,
  APP_SHOWROOM,
  APP_LOAN_TRACKER,
  APP_CREDIT_CONTROL,
  APP_ANALYTICS,
  APP_COMMISSION_TRACKER,
} from './constants';

// used to restrict access to certain paths when a feature is disabled in a country
export const featuresPathRegex = {
  blast: [/^\/campaigns\/[^/]+\/email(\/.*)?$/, /^\/campaigns\/[^/]+\/sms(\/.*)?$/],
};

export const countryFeatures = {
  [COUNTRY_MY]: {
    ...COUNTRIES[COUNTRY_MY],
    enabledApps: [
      APP_SHOWROOM,
      APP_LOAN_TRACKER,
      APP_CREDIT_CONTROL,
      APP_ANALYTICS,
      APP_COMMISSION_TRACKER,
    ],
    features: {
      creditCheck: true,
      salescandy: true,
      srb: true,
      oppPayment: false,
      promotionBlast: true,
    },
  },
  [COUNTRY_ID]: {
    ...COUNTRIES[COUNTRY_ID],
    enabledApps: [
      APP_SHOWROOM,
      APP_ANALYTICS,
      APP_CREDIT_CONTROL,
    ],
    features: {
      creditCheck: false,
      salescandy: true,
      srb: true,
      oppPayment: false,
      promotionBlast: false,
    },
  },
  [COUNTRY_VN]: {
    ...COUNTRIES[COUNTRY_VN],
    enabledApps: [
      APP_SHOWROOM,
      APP_ANALYTICS,
      APP_CREDIT_CONTROL,
    ],
    features: {
      creditCheck: false,
      salescandy: false,
      srb: true,
      oppPayment: true,
      promotionBlast: false,
    },
  },
};
